export enum NodeType {
    DATABASE = 'database',
    SUB_TYPE = 'subtype',
}
